import React, { useState, useEffect } from 'react';
import "../intac_kl_page/intac_kl_page.css";
import "../intac_kl_page/intac_speaker_2026.css";
import "../intac_kl_page/intac_technicalVisit.css";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import infoIcon from "../../parm_assets/tree_icons.png";
import workerImg from "../../parm_assets/about_us/im_tree.jpg"; // replace with your local image
import isaLogo from "../../parm_assets/intackl_2.png"; // replace with your local image
import safeTreeLogo from "../../parm_assets/parm_logo_2.png"; // replace with your local image
import arborist from "../../parm_assets/intac_kl/arborist.png";
import horticulture from "../../parm_assets/intac_kl/holticulture.png";
import landscape_arc from "../../parm_assets/intac_kl/landscape_arc.png";
import planner from "../../parm_assets/intac_kl/planner.png";
import urban_forester from "../../parm_assets/intac_kl/urban_forester.png";
import engineer from "../../parm_assets/intac_kl/engineer.png";
import researchers from "../../parm_assets/intac_kl/researchers.png";
import developers from "../../parm_assets/intac_kl/developers.png";
import policy_maker from "../../parm_assets/intac_kl/policy_maker.png";
import private_comp from "../../parm_assets/intac_kl/private_company.png";
import academicians from "../../parm_assets/intac_kl/academicians.png";
import interested_indv from "../../parm_assets/intac_kl/interested_individual.png";
import register_form_qr from "../../parm_assets/intac_kl/register_form_intac.jpeg";
import intac_logo_bulat from "../../parm_assets/intac_kl/INTAC Logo bulat.png";
import intac_logo_hijau from "../../parm_assets/intac_kl/INTAC_LOGO_hijau.png"

import speaker1 from "../../parm_assets/intac_kl/SPEAKER_WEB/Catlyn.png";
import speaker2 from "../../parm_assets/intac_kl/SPEAKER_WEB/Mansor.png";
import speaker3 from "../../parm_assets/intac_kl/SPEAKER_WEB/ISkander Zul.png";
import speaker4 from "../../parm_assets/intac_kl/SPEAKER_WEB/Francesco Ferrini.png";
import speaker5 from "../../parm_assets/intac_kl/SPEAKER_WEB/Samuel Ma.png";
import speaker6 from "../../parm_assets/intac_kl/SPEAKER_WEB/Khariza Abd.png";
import speaker7 from "../../parm_assets/intac_kl/SPEAKER_WEB/Shinjiro Umezu.png";
import speaker8 from "../../parm_assets/intac_kl/SPEAKER_WEB/Chan Chung.png";
import speaker9 from "../../parm_assets/intac_kl/SPEAKER_WEB/Ahmad Yusri.png";
import speaker10 from "../../parm_assets/intac_kl/speaker_new/LAR. SHAQHRONY.png";
import speaker11 from "../../parm_assets/intac_kl/speaker_new/CA MARK HARTLEY.png";
import speaker12 from "../../parm_assets/intac_kl/speaker_new/ORAYA.png";
import speaker13 from "../../parm_assets/intac_kl/speaker_new/JONATHAN PICKER.png";
import speaker14 from "../../parm_assets/intac_kl/speaker_new/LAR CA BENYAMIN.png";
import speaker15 from "../../parm_assets/intac_kl/speaker_new/PROF.AIN.png";
import speaker16 from "../../parm_assets/intac_kl/speaker_new/CA IKHMAL.png";
import speaker17 from "../../parm_assets/intac_kl/speaker_new/CA SAID SAJAP.png";
import speaker18 from "../../parm_assets/intac_kl/speaker_new/PROF NAZRRE.png";
import speaker19 from "../../parm_assets/intac_kl/speaker_new/CA DR NAZARUDDIN.png";
import speaker20 from "../../parm_assets/intac_kl/speaker_new/DR DZEMAN.png";
import speaker21 from "../../parm_assets/intac_kl/speaker_new/DR RAHMAD ZAKARIA.png";
import speaker22 from "../../parm_assets/intac_kl/speaker_new/LAR SAIFUDDIN.png";
import speaker23 from "../../parm_assets/intac_kl/speaker_new/TAN KIM.png";
import speaker24 from "../../parm_assets/intac_kl/speaker_new/PETER SASI.png";


import { Download } from 'lucide-react';
import IntacLogo04 from "../../parm_assets/intac_kl/INTAC Logo-04.png";
import hotel from "../../parm_assets/intac_kl/hotel.webp";
import { Map, Marker } from 'pigeon-maps';
import waze from "../../parm_assets/intac_kl/waze.png";
import googlemaps from "../../parm_assets/intac_kl/google-maps.png";
import abstractIntruction from "../../parm_assets/intac_kl/attachment/ABSTRACT Instruction and Template.pdf";
import abstractPosterGuideline from "../../parm_assets/intac_kl/attachment/INTAC poster guideline.pdf";
import tentative from "../../parm_assets/intac_kl/INTAC Seberang Perai 2026 - Final.pdf";


const intacBkg = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC_BANNER_NEW.png?updatedAt=1769929468176";
const intac2026 = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC%202026%20poster-for%20puteri-2.png";
const intacpenang = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC_Logo-1-removebg-preview.png";
const intacnewimage = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/PNG/intaclatest.png";
const sponsorship = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/SPONSORSHIPS%20TO%20WEB-20.png"
const intacpackages = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/PNG/Artboard%207.png";
const scanqr = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/parm%20QR.png?updatedAt=1772079341631";
const position = [5.3941, 100.398];

const PenangRiverCruise = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/Penang-River-Cruise-11.jpg";
const KampungAgong = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/Kampung%20Agong.jpg";
const PenangHill = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/Penang%20Hill2.jpeg";
const TamanNegaraPenang = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/Taman%20Negara.png";
const TamanBotaniPenang = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/TAman%20botani.jpg";
const RoyalBelum = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/forest_belum-.jpeg";


const professions = [
  { name: 'Arborists and Tree Care Professionals', icon: arborist },
  { name: 'Landscape Architects and Urban Planners', icon: landscape_arc},
  { name: 'Environmental and Forestry Agencies', icon: planner },
  { name: 'Urban Foresters and Landscape Managers', icon: urban_forester },
  { name: 'Green Industry Professionals', icon: horticulture },
  // { name: 'Researchers', icon: researchers },
  { name: 'Developers and Infrastructure Professionals', icon: developers },
  { name: 'Policy Makers and Sustainability Advocates', icon: policy_maker},
  { name: 'Environmental NGOs and Community Groups', icon: private_comp },
  { name: 'Researchers, Academicians and Students', icon: academicians },
  { name: 'Municipal and Local Government Officials', icon: interested_indv },

];

const processSteps = [
    {
      id: "01",
      title: "What We Offer",
      description: " 📣 More than 30 oral presentations, demonstrations and workshops presented by practitioners and researchers from the arboriculture fraternity\n 👨‍🏫 Learned from the best and exchange wisdom with others."
    },
    // {
    //   id: "02",
    //   title: "Grow Your Network",
    //   description: "This events provide insightful experience to build connection with fellow arborist practitioner"
    // },
    // {
    //   id: "03",
    //   title: "Gateway to Global Knowledge",
    //   description: "Learned from the best and exchange wisdom with others."
    // },
    {
      id: "02",
      title: "Conference Inclusions",
      description: " 🌿 Technical Visits: Penang Sites (Included) or Royal Belum Expedition (Additional Charges Apply*)\n 📜 E-Certificate\n 🎁 Conference T-shirt & Goodie Bag (worth RM100)\n 🏷️ Name Tag\n 🤝 Networking with Experts & Industry "
    }
  ];

  const objectiveData = [
    {
      id: '01',
      text: 'Promote climate resilience strategies for urban trees through scientific research, adaptive management, and urban design solutions.',
    },
    {
      id: '02',
      text: 'Highlight best practices and innovations in tree care, species selection, risk assessment, soil management, and advanced arboricultural techniques.',
    },
    {
      id: '03',
      text: 'Strengthen policy and planning frameworks that support sustainable urban forestry and integrated green infrastructure.',
    },
    {
      id: '04',
      text: 'Enhance community engagement in tree stewardship, public education, and participatory urban greening efforts.',
    },
    {
      id: '05',
      text: 'Showcase the ecological value of urban biodiversity and the ecosystem services provided by trees',
    },
    {
      id: '06',
      text: 'Explore emerging technologies such as GIS mapping, remote sensing, digital inventories, AI-driven diagnostics, and tree performance monitoring',
    },
    {
      id: '07',
      text: 'Promote conservation and restoration of resilient landscapes, including heritage trees and culturally significant green spaces',
    },
  ];

  const navIntacItems = [
    { label: 'Home', target: 'conference-hero-intac2026' },
    { label: 'Objective', target: 'objective-intac' },
    { label: 'Abstract', target: 'abstract-intac' },
    { label: 'Speaker', target: 'speakers-section'},
    { label: 'Sponsorship', target: 'sponsorship-intac' },
    { label: 'Fee', target: 'fee-payment' },
    { label: 'Registration', target: 'registration-intac' },
    { label: 'Venue', target: 'venue-intac' },
  ];

  const fees = [
    { label: "Early Birds (Before 31st May 2026)", sub: "(Before 31st May 2026)", price: "RM1,275" },
    { label: "PArM Member", price: "RM1,400" },
    { label: "Non-PArM Members", price: "RM1,500" },
    { label: "Students", price: "RM1,200" },
    { label: "International", sub: "(USD 350)", price: "USD450" },
    // { label: "Booth", price: "RM3,000" },
  ];

  const speakersData = [
  {
    id: 1,
    name: "Ms. Caitlyn Pollihan",
    title: "International Society of Arboriculture (ISA)",
    country: "CEO",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker1
  },
  {
    id: 2,
    name: "Hj Mansor Mohamad",
    title: "National Landscape Department",
    country: "Director General",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker2
  },
  {
    id: 15,
    name: "CA Prof. Dr. Ahmad Ainuddin Nuruddin FASc.",
    title: "",
    country: "Institute of Tropical Forestry and Forest Products, UPM",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker15
  },
   {
    id: 3,
    name: "Prof. Dr. Francesco Ferrini",
    title: "",
    country: "University of Florence",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker4
  },
  {
    id: 5,
    name: "Samuel Ma",
    title: "Consulting Arborist & Climbing Specialist",
    country: "Director",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker5
  },
   {
    id: 10,
    name: "CA Shaqhrony Md Yusoff",
    title: "",
    country: "Majlis Bandaraya Seberang Perai",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker10
  },
  {
    id: 11,
    name: "CA Mark Hartley",
    title: "",
    country: "Arborist Training Network",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker11
  },
  {
    id: 7,
    name: "Prof. Dr. Shinjiro Umezu",
    title: "",
    country: "Waseda University",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker7
  },
  {
    id: 13,
    name: "CA Jonathan Picker",
    title: "",
    country: "Asia Tree Preservation",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker13
  },
  {
    id: 8,
    name: "Chan Chung Leong",
    title: "National Parks Board",
    country: "Director (Streetscape)",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker8
  },
  {
    id: 12,
    name: "Oraya Sutabutr",
    title: "",
    country: "Thai Arboriculture Association",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker12
  },
  {
    id: 9,
    name: "Prof. Dr. Ir. Iskandar Zulkarnaen",
    title: "Indonesian Society of Arboriculture",
    country: "Chairperson",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker3
  },
  

  
  {
    id: 14,
    name: "CA Mohd Benyamin Julaihi Khan",
    title: "",
    country: "Dewan Bandaraya Kuching Utara, Sarawak",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker14
  },
   
  {
    id: 16,
    name: "CA Nik Ikmal Fathi Nik Husain Fathi",
    title: "",
    country: "Persatuan Arborist Malaysia",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker16
  },
  {
    id: 17,
    name: "CA Dr. Ahmad Said Sajap",
    title: "",
    country: "Persatuan Arborist Malaysia",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker17
  },
  {
    id: 18,
    name: "Prof. Dr. Mohd Nazre Saleh",
    title: "",
    country: "Persatuan Arborist Malaysia",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker18
  },
   {
    id: 19,
    name: "CA Dr. Ahmad Nazaruddin Mohd Roseli",
    title: "",
    country: "Forest Research Institute Malaysia",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker19
  },
  {
    id: 20,
    name: "Dr. Dzaeman Dzulkifli",
    title: "",
    country: "Tropical Rainforest Conservation and Research Centre (TRCRC)",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker20
  },
  {
    id: 21,
    name: "CA Assoc Prof. Dr. Rahmad Zakaria",
    title: "",
    country: "Universiti Sains Malaysia",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker21
  },
  {
    id: 4,
    name: "Ahmad  Yusri Mat Yusoff",
    title: "",
    country: "Sime Darby Property",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker9
  },
   
   {
    id: 6,
    name: "Khariza Abd Khalid",
    title: "Gamuda Land",
    country: "Executive Director",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker6
  },
   {
    id: 22,
    name: "Mohd. Saifuddin Ali",
    title: "",
    country: "National Landscape Department",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker22
  },
  {
    id: 23,
    name: "CA Tan Kim Hock",
    title: "",
    country: "Universiti Putra Malaysia",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker23
  },
  {
    id: 24,
    name: "Peter Sasi",
    title: "Asia Pacific Greehill",
    country: "Vice President",
    // bio: "Dr. Menon is a leading researcher in tropical urban forestry, focusing on climate adaptation strategies and long-term tree health.",
    image: speaker24
  },
];

const SpeakerCard = ({ speaker }) => (
  <div className="speaker-card">
    <div className="image-container">
      <img src={speaker.image} alt={speaker.name} />
    </div>
    <div className="speaker-info">
      <h3>{speaker.name}</h3>
      <p className="speaker-title">{speaker.country}</p>
       <p className="speaker-country">{speaker.title}</p>
      <p className="speaker-bio">{speaker.bio}</p>
    </div>
  </div>
);

const technicalVisitLoc = [
  { id: 1, src: PenangRiverCruise, alt: 'Penang River Cruise' },
  { id: 2, src: KampungAgong, alt: 'Kampung Agong' },
  { id: 3, src: PenangHill, alt: 'Penang Hill' },
  { id: 4, src: TamanNegaraPenang, alt: 'Taman Negara Penang' },
  { id: 5, src: TamanBotaniPenang, alt: 'Taman Botani Penang' },
  { id: 6, src: RoyalBelum, alt: 'Royal Belum Perak*' },
  
];



const IntacKL = () => {
  const [daysToGo, setDaysToGo] = useState(0);

  useEffect(() => {
    // Set target date for INTAC 2026 (e.g., September 1, 2026)
    const targetDate = new Date('2026-09-21T00:00:00').getTime();

    const calculateDays = () => {
      const now = new Date().getTime();
      const difference = targetDate - now;
      const days = Math.ceil(difference / (1000 * 60 * 60 * 24));
      setDaysToGo(days > 0 ? days : 0);
    };

    calculateDays();
    const timer = setInterval(calculateDays, 1000 * 60 * 60); // Update hourly

    return () => clearInterval(timer);
  }, []);
  
  return (
    
    <div className="page-container-INTAC">
      {/* <section className="intackl-hero-section">
        <div className="intac-hero-content" style={{ backgroundImage: `url(${intacBkg})` }}>
        // gggg
        </div>
      </section> */}

       {/* <section className="about-section">
            <div className="about-container">
              <div className="about-left">
                <div className="image-grid">
                  <img src={workerImg} alt="Tree Worker" className="main-img" />
                  <div className="badge_intac">
                    <h2>22 - 24</h2>
                    <p>September 2026 <br /> Seberang Perai, Penang</p>
                  </div>
                  <img src={isaLogo} alt="ISA Logo" className="isa-img" />
                </div>
              </div>
      
              <div className="about-right">
                <p className="about-tag">
                  <img src={infoIcon} alt="icon" className="about-icon" />
                  INTAC 2026
                  </p>
                <h2 className="about-title">
                  Advancing Arboriculture:  <br />Resilient Trees for Sustainable Cities
                </h2>
                <p className="about-desc">
                  The Malaysian Society of Arborist or better known by its local acronym PArM (Persatuan Arborist Malaysia) is organizing an International Tropical Arboriculture Conference (INTAC 2026) in September, 2026 with the theme of  Advancing Arboriculture: Resilient Trees for Sustainable Cities. The Conference will be held at The Light Hotel, Seberang Perai, Penang from 22nd until 24th September 2026.
                </p>
                <button className="read-btn-intac">
                 Explore More <span className="arrow-intac">→</span>
                </button>
      
                <div className="vision-mission">
                  <div className="vm-card">
                    <div className="vm-header">
                      <div className="circle"></div>
                      <h3>Venue</h3>
                    </div>
                    <p>The Light Hotel, Seberang Perai, Penang</p>
                  </div>
      
                  <div className="vm-card">
                    <div className="vm-header">
                      <div className="circle"></div>
                      <h3>Date</h3>
                    </div>
                    <p>
                      22th until 24th September 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          <section id="conference-hero-intac2026" className="intac2026-section">
            
      <div className="intac2026-container">

         <div className="intac-new-image">

          <nav className="navbar-intac">
        <ul className="nav-intac-links">
          {navIntacItems.map((item) => (
            <li key={item.target}>
              <a href={`#${item.target}`}>{item.label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <div className="line-intac"> </div>

          <img src={intacnewimage} alt=" " className="intac-new-image-news"/>
          {/* <img src={sponsorship} alt=" " className="intac-new-image-sponsorship"/> */}

          <div className="intac-sponsorship-wrapper">
          <img src={sponsorship} alt="Sponsorship Banner" className="intac-new-image-sponsorship" />
          
          <div className="intac-countdown-overlay">
            <img 
              src="https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC%20Logo-04.png?updatedAt=1769929448620" 
              alt="INTAC Logo" 
              className="intac-overlay-logo" 
            />
            <span className="intac-divider">|</span>
            <span className="intac-countdown-text">
              <strong>{daysToGo}</strong> days to go
            </span>
          </div>
        </div>
          
{/* 
          <div className="intac-overlay">
            <div className="intac-content-wrapper">
            <h3 className="intac2026-tagline">
              WELCOME TO <br/>INTAC 2026
            </h3>

            <p className="intac2026-description">
            Urban environments around the world are experiencing unprecedented pressures from rapid development, climate change, and increasing population density. As cities expand, urban trees and green spaces—collectively known as urban forests—play a crucial role in sustaining environmental health, 
            improving community well-being, and enhancing climate resilience. Arboriculture, the science and practice of cultivating and managing trees, is therefore central to building sustainable, livable, and resilient cities. <br/> <br/>
            The conference, <strong>“Advancing Tropical Arboriculture: Towards Sustainable Cities”</strong> aims to bring together arborists, urban planners, researchers, policymakers, landscape architects, and green industry professionals to explore innovative strategies for strengthening the health and resilience of urban trees. 
            It provides a platform to share insights, foster collaboration, and promote best practices in urban tree management. Through knowledge sharing, technical discussions, and case studies, the conference seeks to advance best practices in tree selection, establishment, maintenance, risk management, and 
            ecosystem-based urban design. By promoting collaboration and science-based approaches, the event supports the development of greener, more sustainable tropical cities where trees can thrive despite environmental and urban pressures.

          </p>
          </div>

          <div className="sub-theme-section1-intac2026">
            <h4>Sub Themes</h4>
            <ul>
              <li>Urban Tree Resilience and Climate Adaptation</li>
              <li>Arboriculture Best Practices and Innovations</li>
              <li>Urban Forestry Policy and Planning</li>
              <li>Community Engagement and Education</li>
              <li>Biodiversity, Ecology and Ecosystem Services</li>
              <li>Technology and Data in Arboriculture</li>
              <li>Resilient Landscapes and Heritage Trees</li>
            </ul>
          </div>
      </div> */}

      
        </div>

          
        {/* <div className="intac2026-text-side">
            <span className="small-label-intac2026">
                <img src={infoIcon} alt="icon" className="tree-icon" />
                INTAC SEBERANG PERAI</span>
          <header className="intac2026-branding">
            <div className="logo-box-intac2026">
              <img src={intacpenang} alt="INTAC Logo" />
            </div>
      
          </header>

          <h3 className="intac2026-tagline">
            Advancing Tropical Arboriculture: Towards Sustainable Cities
          </h3>

          <p className="intac2026-description">
            Urban environments around the world are experiencing unprecedented pressures from rapid development, climate change, and increasing population density. As cities expand, urban trees and green spaces—collectively known as urban forests—play a crucial role in sustaining environmental health, 
            improving community well-being, and enhancing climate resilience. Arboriculture, the science and practice of cultivating and managing trees, is therefore central to building sustainable, livable, and resilient cities. <br/> <br/>
            The conference, <strong>“Advancing Tropical Arboriculture: Towards Sustainable Cities”</strong> aims to bring together arborists, urban planners, researchers, policymakers, landscape architects, and green industry professionals to explore innovative strategies for strengthening the health and resilience of urban trees. 
            It provides a platform to share insights, foster collaboration, and promote best practices in urban tree management. Through knowledge sharing, technical discussions, and case studies, the conference seeks to advance best practices in tree selection, establishment, maintenance, risk management, and 
            ecosystem-based urban design. By promoting collaboration and science-based approaches, the event supports the development of greener, more sustainable tropical cities where trees can thrive despite environmental and urban pressures.

          </p>
        </div> */}

        {/* Right Column: Poster Card */}
        {/* <div className="intac2026-visual-side">
          <div className="floating-badge-intac2026">
            <div className="badge-date-intac2026">22 – 24</div>
            <div className="badge-month-intac2026">September 2026</div>
            <div className="badge-loc-intac2026">Seberang Perai, Penang, Malaysia</div>
          </div>

=          <div className="outer-frame-intac2026">
            <div className="inner-poster-intac2026">
              <Zoom>
              <img src={intac2026} alt="INTAC Poster" className="main-poster-img-intac2026" />
              </Zoom>
             
            </div>
          </div>
        </div> */}
      </div>
    </section>

    <section id="objective-intac" className="objectives-intac-section">
      <div className="container-objective-intac">
        <div className="header-objective-intac">
          <span className="subtitle-objective-intac">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            INTAC OBJECTIVES</span>
          <h2 className="title-objective-intac">Objectives</h2>
        </div>

        <div className="cards-grid-objective-intac">
          {objectiveData.map((obj) => (
            <div key={obj.id} className="objective-card-objective-intac">
              <div className="number-badge-objective-intac">{obj.id}</div>
              <div className="card-content-objective-intac">
                <p>{obj.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <div className="container-intac2026">
      <div className="grid-layout-intac2026">
        
        {/* Left Section: Process Overview */}
        <section className="left-section-intac2026">
          <span className="small-label-intac2026">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            INTAC OVERVIEW</span>
          <h1 className="main-title-intac2026">Unforgettable Meetup With Fellow Arborist</h1>
          
          <div className="process-list-intac2026">
            <div className="vertical-line-intac2026"></div>
            {processSteps.map((step) => (
              <div key={step.id} className="process-item-intac2026">
                <div className="step-number-intac2026">{step.id}</div>
                <div className="content-card-intac2026">
                  <h3>{step.title}</h3>
                  <p style={{ whiteSpace: 'pre-wrap' }}>
                      {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <span className="small-label-intac2026" style={{ marginTop: '70px' }}>
            <img src={infoIcon} alt="icon" className="tree-icon" />
            PROGRAM TENTATIVE</span>
          <h1 className="main-title-intac2026">INTAC 2026 Program</h1>
          
           <div className="pdf-download-container-intac" >
              {/* Button 1: Registration Form Guide */}
              <a 
                href= {tentative} 
                download="INTAC Seberang Perai 2026 - Final.pdf"
                className="intac-download-btn"
              >
                <Download size={16} />
                <span>Download INTAC Program</span>
              </a>

            </div>
          
        </section>

        {/* Right Section: Abstract */}
        <section id="abstract-intac" className="right-section-intac2026">
          <span className="small-label-intac2026">
            <img src={infoIcon} alt="icon" className="tree-icon" />
            ABSTRACT</span>
          <h1 className="main-title-intac2026">Call for Papers</h1>
          <p className="intro-text-intac2026">
            Papers on topics relevant to the conference theme are invited for presentation. Authors must register and submit abstracts not exceeding 500 words and including the following information: 
            title, author names, affiliations, corresponding email, and five keywords. Abstracts should be prepared on 
            A4-sized page and typed single-spaced in 11-point Times New Roman, using Microsoft Word 2007 or later (preferred), with 2.5 cm margins on all sides.
          </p>

          <div className="date-cards-intac2026">
            <div className="date-card-intac2026">
              <div className="circle-1"></div>
              <div>
                <h4>Abstract Submission</h4>
                <p>✓ 30 June 2026</p>
              </div>
            </div>
            <div className="date-card-intac2026">
              <div className="circle-1"></div>
              <div>
                <h4>Notification of Acceptance</h4>
                <p>✓ 30 July 2026</p>
              </div>
            </div>
          </div>

          <div className="sub-theme-box-intac2026">
            <h4>Sub Theme</h4>
            <ol>
              <li>Arboriculture Policy and Planning</li>
              <li>Urban Tree Resilience and Climate Adaptation</li>
              <li>Arboriculture Best Practices and Innovations</li>
              <li>Biodiversity, Ecology and Ecosystem Services</li>
              <li>Technology and Data in Arboriculture</li>
            </ol>
          </div>

          <div className="abstract-register-intac2026">
            <h1 className="main-title-abstract-register">Registration</h1>
            <p className="intro-text-abstract-register">
            For registration and submission of abstract(s), You may contact the conference secretary for further information:<br/> <br/>
            <strong>intacseberangperai@gmail.com</strong><br/>

          </p>

          {/* 🟢 NEW: PDF Downloads Container Block */}
            <div className="pdf-download-container-intac">
              {/* Button 1: Registration Form Guide */}
              <a 
                href= {abstractIntruction} 
                download="INTAC2026_Abstract_Instructions.pdf"
                className="intac-download-btn"
              >
                <Download size={16} />
                <span>Download Abstract Instruction and Template</span>
              </a>

              {/* Button 2: Abstract Template Guide */}
              <a 
                href={abstractPosterGuideline} 
                download="INTAC2026_Abstract_Poster_Guideline.pdf"
                className="intac-download-btn"
              >
                <Download size={16} />
                <span>Download Poster Guideline</span>
              </a>
            </div>
          </div>
        </section>
        
      </div>
    </div>    


    <section className="technical-visit-container">
      <h2 className="technical-visit-title">Technical Visit</h2>
      
      <div className="technical-visit-slider">
        <div className="technical-visit-slide-track">
          {/* First set of logos */}
          {technicalVisitLoc.map((logo) => (
            <div className="technical-visit-slide" key={logo.id}>
              <div className="slide-content">
                <Zoom>
              <img src={logo.src} alt={logo.alt} />
              </Zoom>
              <p className="technical-visit-location">{logo.alt}</p>
              </div>
            </div>
          ))}
          {/* Duplicate set for seamless looping */}
          {technicalVisitLoc.map((logo) => (
            <div className="technical-visit-slide" key={`clone-${logo.id}`}>
              <div className="slide-content">
                <Zoom>
              <img src={logo.src} alt={logo.alt} />
              </Zoom>
              <p className="technical-visit-location">{logo.alt}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="technical-visit-star">*2 Days 1 Night with additional fee RM650</p>
    </section>


    <section id='speakers-section' className="speakers-section">
      <div className="container">
        <header className="section-header">
          <div className="header-content">
             <div className="logo-mark"> 
              <img src={intac_logo_hijau} className='intac_logo_bulat' /> 
              </div>
             <h2>SPEAKERS HIGHLIGHTS</h2>
          </div>
        </header>
        
        <div className="speakers-grid">
          {speakersData.map(speaker => (
            <SpeakerCard key={speaker.id} speaker={speaker} />
          ))}
        </div>
      </div>
    </section>


              <section className="container-intac-attend">
                <div className="header-box-intac-attend">
                    <span className="subtitle-intac-attend">
                      <img src={infoIcon} alt="icon" className="tree-icon" />
                      HEAR FROM THE PROFESSIONALS</span>
                    <h2 className="title-intac-attend">Who Should Attend</h2>
                </div>

                <div className="grid-intac-attend">
                    {professions.map((item, index) => (
                    <div 
                        key={index} 
                        className={`card-intac-attend ${item.highlighted ? 'highlighted-intac-attend' : ''}`}
                    >
                        <div className="image-wrapper-intac-attend">
                        <img src={item.icon} alt={item.name} />
                        </div>
                        <span className="name-intac-attend">{item.name}</span>
                    </div>
                    ))}
                </div>
                </section>

                <section id="sponsorship-intac" className="intac2026-packages-section">
            
      <div className="intac2026-container">
         <div className="intac-new-image">
          <img src={intacpackages} alt=" " className="intac-new-image-news"/>
        </div>
      </div>
    </section>

       <section id='fee-payment' className="intac-container-2026Page1-section2">
          {/* Left Column: Exploring INTAC Programme */}
          {/* <div className="intac-2026Page1-section2"> */}
            <div className="header-2026Page1-section2">
              <span className="small-label-intac2026">
                              <img src={infoIcon} alt="icon" className="tree-icon" />
                              FEE AND PAYMENT</span>
            </div>
            <h1 className="title-2026Page1-section2">Conference Fee & Payment</h1>
            <div className="overlap-container-2026Page1-section2">
            {/* Top Darker Section */}
            <div className="fee-card-2026Page1-section2 image-bg-top">
              <div className="fee-content-2026Page1-section2">
                <div className="fee-list-2026Page1-section2">
                  {/* <h2 className="section-title-2026Page1-section2">Early Bird (Before 30 June 2026)</h2> */}
                  {fees.map((f, i) => (
                    <div key={i} className="fee-row-2026Page1-section2">
                      <div className="fee-info-2026Page1-section2">
                        <span className="fee-name-2026Page1-section2">{f.label}</span>
                        {/* {f.sub && <span className="fee-sub-2026Page1-section2">{f.sub}</span>} */}
                      </div>
                      <span className="fee-value-2026Page1-section2">{f.price}</span>
                    </div>
                  ))}
                </div>
    
                {/* <div className="fee-list-2026Page1-section2">
                  <h2 className="section-title-2026Page1-section2">Normal (After 30 June 2026)</h2>
                  {fees2.map((f, i) => (
                    <div key={i} className="fee-row-2026Page1-section2">
                      <div className="fee-info-2026Page1-section2">
                        <span className="fee-name-2026Page1-section2">{f.label}</span>
                    
                      </div>
                      <span className="fee-value-2026Page1-section2">{f.price}</span>
                    </div>
                  ))}
                </div> */}
    
                {/* <div className="payment-qr-side-2026Page1-section2">
                  <h2 className="payment-title-2026Page1-section2">Payment</h2>
                  <div className="outer-image-card-2026Page1-section2">
                  <div className="qr-wrapper-2026Page1-section2">
                    <img src="https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=Payment" alt="QR" />
                  </div>
                  </div>
                </div> */}
              </div>
            </div>
    
            {/* Bottom Lighter Section (The Overlap) */}
            <div className="bank-card-2026Page1-section2 image-bg-bottom">
              <div className="fee-content-2026Page1-section2">
                 <div className="payment-qr-side-2026Page1-section2">
                  <h2 className="payment-title-2026Page1-section2">Payment</h2>
                  <div className="outer-image-card-2026Page1-section2">
                  <div className="qr-wrapper-2026Page1-section2">
                    <img src={scanqr} alt="QR" className='qrbank'/>
                  </div>
                  </div>
                </div>
    
              <div className="or-divider-2026Page1-section2">
                <h3 className="account-title-2026Page1-section2">Payment of registration fee should be banked in to RHB Islamic Bank before <strong>11 August 2026</strong>. 
                Kindly provide us with the remittance advice slip for our reference.</h3>
                <h3 className="payment-detail-title">Payment Details</h3>
              <div className="bank-info-2026Page1-section2">
                <p>Cross Cheque Payable To: <strong>PERSATUAN ARBORIST MALAYSIA</strong></p>
                <p>RHB Islamic Account: <strong>21245760009232</strong></p>
                <p>Bank Branch: <strong>BANDAR BARU BANGI</strong></p>
                <p>Swift Code: <strong>RHBAM YKL</strong></p>
              </div>

              <p className="payment-excluded">**Registration fee excludes hotel accommodation. The fee covers two days conference participation, conference F&B, and one technical visit (Royal Belum trip is not included).</p>
              </div>
             
              </div>
            </div>
          </div>
        </section>

        <div className="page-wrapper-2026Page1-section3">
              {/* Top Logo Row */}
              {/* <LogoGrid /> */}
        
              {/* Main Registration Card */}
              <section id="registration-intac" className="registration-card-2026Page1-section3">
                <div className="qr-wrapper-2026Page1-section3">
                  <div className="qr-code-2026Page1-section3">
                    <img 
                      src={register_form_qr} 
                      alt="Registration QR Code" 
                    />
                  </div>
                </div>
        
                <div className="content-wrapper-2026Page1-section3">
                  {/* <span className="event-label-2026Page1-section3">EVENT REGISTRATION <span className="arrow">➤</span></span> */}
                  <h2 className="registration-title-2026Page1-section3">Event Registration</h2>
                
                  <p className="registration-text-2026Page1-section3">
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSdDLus4wnC9FIyronAJGaXT00VhQh2g0vdsmbn1jNCYjNiEKg/viewform" className="registration-link-2026Page1-section3">Click Here : Registration INTAC Seberang Perai 2026 Online Form</a>
                    {" "}or you can scan our QR code for the online registration.
                  </p>
        
                  <div className="closing-date-2026Page1-section3">
                    {/* <span className="check-icon-2026Page1-section3">✓</span> */}
                    Registration Closing Date : <strong> 15 August 2026</strong>
                  </div>
                </div>
              </section>
        
              {/* Bottom Logo Row */}
              {/* <LogoGrid /> */}
            </div>
            
            <section id='venue-intac'>

            <div className="venue-section-2026Page1-section4">
                  <div className="venue-container-2026Page1-section4">
                    {/* Left Column: Text Content */}
                    <div className="venue-text-side-2026Page1-section4">
                      <div className="venue-title-area-2026Page1-section4">
                        <span className="venue-label-2026Page1-section4">
                          <span className="small-label-intac2026">
                                      <img src={infoIcon} alt="icon" className="tree-icon" />
                                      VENUE</span>
                        </span>
                        <h1 className="venue-main-heading-2026Page1-section4">Venue Details</h1>
                      </div>
            
                      <div className="info-list-2026Page1-section4">
                        <div className="info-item-2026Page1-section4">
                          <h3>The Light Hotel</h3>
                          <p>Lebuh Tenggiri 2, 13700 Seberang Jaya, Pulau Pinang</p>
                        </div>
                        
                        <div className="info-item-2026Page1-section4">
                          <h3>The Light Hotel Contact No</h3>
                          <p><u>+604–382 1111</u></p>
                        </div>
            
                        <div className="info-item-2026Page1-section4">
                          <h3>The Light Hotel</h3>
                          <p>https://www.thelighthotelpg.com/</p>
                        </div>
                      </div>
                    </div>
            
                    {/* Right Column: Image and Badge */}
                    <div className="venue-visual-side-2026Page1-section4">
                      <div className="image-wrapper-2026Page1-section4">
                        <div className="intac-badge-2026Page1-section4">
                           <div className="badge-content-2026Page1-section4">
                              <span className="badge-logo-text-2026Page1-section4">
                                <img 
                                  src={IntacLogo04} 
                                  alt="The Light Hotel Building" 
                                  className="intaclogo-img-2026Page1-section4"
                                />
                              </span>
                              {/* <span className="badge-sub-text-2026Page1-section4">SEBERANG PERAI</span> */}
                           </div>
                        </div>
                        <img 
                          src={hotel} 
                          alt="The Light Hotel Building" 
                          className="hotel-img-2026Page1-section4"
                        />
                      </div>
                    </div>
                  </div>
                </div>
            
            
                 <div className="section-container-2026page1-section5">
                  {/* Map Wrapper */}
                  <div className="map-pill-container-2026page1-section5">
                    <Map
                      height={380}
                      defaultCenter={position}
                      defaultZoom={15}
                      // Using a custom provider to get that clean teal/blue look
                      // If you want standard OSM, just remove the provider prop
                     provider={(x, y, z) => `https://tile.openstreetmap.org/${z}/${x}/${y}.png`}
                    >
                      <Marker width={50} anchor={position} color="#1a5f63" />
                    </Map>
                  </div>
            
                  {/* Action Bar */}
                  <div className="action-bar-container-2026page1-section5">
                    <div className="action-bar-2026page1-section5">
                      <span className="action-text-2026page1-section5">Click Here:</span>
                      <div className="icon-group-2026page1-section5">
                        <a
                          href={"https://maps.app.goo.gl/PPn2ZySj1S6VQ9Ms7"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={googlemaps}
                            alt="Google Maps"
                            className="nav-icon-2026page1-section5"
                          />
                        </a>
                        <a
                          href={"https://waze.com/ul/hw0zqsw5f9"}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={waze} alt="Waze" className="nav-icon-2026page1-section5" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                </section>



    {/* <section className="find-out-intact-landing-wrapper">
      <div className="find-out-intact-content">
        <h1 className="find-out-intact--title">Let's Join Intac 2026</h1>

        <button className="find-out-intact-btn" onClick={() => window.location.href = '/intac2026-page1-parm'}>
          Find out more ↗
        </button>

      </div>
    </section> */}
    </div>
  );
};

export default IntacKL;